export default __webpack_public_path__ + "static/media/bruno.d2d72f88.svg";